import { useContext } from "react";
import { AppConfigContext } from "../providers/AppConfigProvider";

export const useAppConfig = () => {
  const context = useContext(AppConfigContext);

  if (context === null) {
    throw new Error("useAppConfig must be used within a AppConfigProvider");
  }

  return context;
};
